import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexFeePaymentProcessesRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/fee_payment_processes`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const showFeePaymentProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/fee_payment_processes/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const createFeePaymentProcessRequest = ({ dispatch, params, successCallback, callback, service = 'payroll' }) =>
  ApiService.request('post', `/fee_payment_processes`, {
    dispatch,
    params,
    formData: true,
    successCallback,
    callback,
    service
  });

export const deleteFeePaymentProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('delete', `/fee_payment_processes/${id}`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const closeFeePaymentProcessRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('put', `/fee_payment_processes/${id}/close`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const massiveDestroyFeePaymentProcessRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('delete', `/fee_payment_processes/massive_destroy`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const exportFeePaymentProcessesRequest = ({
  dispatch,
  params = {},
  failureCallback,
  successCallback,
  callback
}) =>
  ApiService.request('get', `/fee_payment_processes/export.xlsx`, {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback,
    callback
  });

export const feePaymentProcessSummaryRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('get', `/fee_payment_processes/${id}/summary`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePaymentProcessSummaryExportRequest = ({
  dispatch,
  params = {},
  successCallback,
  callback,
  service = 'payroll'
}) =>
  ApiService.request('get', `/fee_payment_processes/export_summary.xlsx`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const feePaymentProcessReloadRequest = (
  id,
  { dispatch, params = {}, successCallback, callback, service = 'payroll' }
) =>
  ApiService.request('put', `/fee_payment_processes/${id}/reload`, {
    dispatch,
    params,
    successCallback,
    callback,
    service
  });

export const debounceFeePaymentProcessSummaryRequest = AwesomeDebouncePromise(feePaymentProcessSummaryRequest, 300);
